import { Component } from '@angular/core';
import { ROUTES, FOOTER_ROUTES_OPTIONS, FOOTER_ROUTES_POLITCS } from 'src/app/const/routes';
import { EnumPages } from 'src/app/enum/pages';
import { Route } from 'src/app/models/route';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  public routes: Route[] = ROUTES

  public routesPolitics: Route[] = FOOTER_ROUTES_POLITCS
  public routesOptions: Route[] = FOOTER_ROUTES_OPTIONS

  public routesMenu(){
    return this.routes.filter(x => x.name != EnumPages.HOME && x.name != EnumPages.SETTINGS )
  }
  
  public goToLink(url: string){
    window.open(url, "_blank");
  }

}
